import React from 'react';
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
} from '@mui/material';
import {
  SelectionMap,
  ServiceSelection,
} from '../hooks/useDeployServiceSelection';
import { SITE_BATCH_SERVICE_CATALOG } from '../../../models/SiteBatch';
import ServiceModeRow from './ServiceModeRow';

export interface ServiceSelectionTableProps {
  projectId: string | null;
  site: string;
  selection: SelectionMap;
  onServiceChange: (appname: string, next: ServiceSelection) => void;
  /** 현장 통합서버 배포 — 빌드 없이 사내 이미지 승격(reuse)·배포안함만. */
  remote?: boolean;
}

/**
 * Presentational 8-row table for the deploy dialog. Iterates the canonical
 * batch catalog (keeps ordering stable regardless of Map key order) and
 * delegates each row to `ServiceModeRow`.
 */
export default function ServiceSelectionTable({
  projectId,
  site,
  selection,
  onServiceChange,
  remote = false,
}: ServiceSelectionTableProps) {
  return (
    <TableContainer component={Paper} variant="outlined" sx={{ mt: 1 }}>
      <Table size="small" data-testid="service-selection-table">
        <TableHead>
          <TableRow>
            <TableCell>서비스</TableCell>
            <TableCell>모드</TableCell>
            <TableCell>버전</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {SITE_BATCH_SERVICE_CATALOG.map((svc) => {
            const current = selection.get(svc.appname) ?? { mode: 'build' as const };
            return (
              <ServiceModeRow
                key={svc.appname}
                projectId={projectId}
                appname={svc.appname}
                label={svc.label}
                site={site}
                value={current}
                onChange={(next) => onServiceChange(svc.appname, next)}
                remote={remote}
              />
            );
          })}
        </TableBody>
      </Table>
    </TableContainer>
  );
}
